import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { createClaim } from '../actions/claims';
import { listInsurers } from '../actions/insurers';

import Page from '../components/Page';
import FileClaimForm from '../components/FileClaimForm';

class FileClaim extends Component {
  render() {
    return (
      <Page pageTitle="File Claim">
        <div className="card col-sm-8 col-md-6">
          <FileClaimForm />
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  insurers: state.insurers,
  claims: state.claims
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ createClaim, listInsurers }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FileClaim);



// WEBPACK FOOTER //
// ./src/pages/FileClaim.js